import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSangre/descargarArchivoControlSangre`, method: 'POST', body: values, token: token})
}